import { ResourcesItem } from '@/components/ui/data-display/resources-item/ResourcesItem';
import { bordersList } from '@mage-ui/styled-system/recipes';

export const ResourcesItemLink = ({ data }) => {
  return (
    <li key={data?.meta?.key} className={bordersList().item}>
      <ResourcesItem data={data} />
    </li>
  );
};

export const ResourcesItemFile = ({ data }) => {
  return (
    <li key={data?.meta?.key} className={bordersList().item}>
      <ResourcesItem data={data} />
    </li>
  );
};

export const ResourceItem = {
  Link: ResourcesItemLink,
  File: ResourcesItemFile,
};
